var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPricingFreePlan(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_388_1950)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.2543 22.085H9.75012V18.6591C9.75012 17.8599 10.398 17.2119 11.1973 17.2119H12.8071C13.6064 17.2119 14.2543 17.8598 14.2543 18.6591V22.085Z",
    fill: "url(#paint0_linear_388_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2543 22.085V18.6591C14.2543 17.8599 13.6064 17.2119 12.8071 17.2119H11.1973C10.3981 17.2119 9.75012 17.8598 9.75012 18.6591V19.0195L12.8155 22.0849H14.2543V22.085Z",
    fill: "url(#paint1_linear_388_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9396 24.0004H5.06154C4.8119 24.0004 4.6095 23.798 4.6095 23.5484V23.2981C4.6095 22.3012 5.41759 21.4932 6.41439 21.4932H17.5866C18.5834 21.4932 19.3915 22.3013 19.3915 23.2981V23.5484C19.3916 23.798 19.1892 24.0004 18.9396 24.0004Z",
    fill: "url(#paint2_linear_388_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9619 19.2834H2.03863C1.10371 19.2834 0.345825 18.5255 0.345825 17.5906V5.30706C0.345825 4.37214 1.10371 3.61426 2.03863 3.61426H21.9619C22.8968 3.61426 23.6547 4.37214 23.6547 5.30706V17.5906C23.6547 18.5255 22.8968 19.2834 21.9619 19.2834Z",
    fill: "url(#paint3_linear_388_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.72713 4.84863H21.2718C21.8147 4.84863 22.2547 5.28868 22.2547 5.8315V17.0668C22.2547 17.6097 21.8147 18.0498 21.2718 18.0498H2.72713C2.18431 18.0498 1.74426 17.6097 1.74426 17.0668V5.8315C1.74422 5.28868 2.18426 4.84863 2.72713 4.84863Z",
    fill: "url(#paint4_linear_388_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7781 17.447H3.21589C2.8357 17.447 2.52747 17.1388 2.52747 16.7586V6.1396C2.52747 5.75941 2.83565 5.45117 3.21589 5.45117H20.7781C21.1582 5.45117 21.4665 5.75936 21.4665 6.1396V16.7586C21.4665 17.1388 21.1582 17.447 20.7781 17.447Z",
    fill: "url(#paint5_linear_388_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.16644 7.91096L12.5389 19.2834H21.9619C22.8968 19.2834 23.6547 18.5255 23.6547 17.5906V5.30706C23.6547 4.37214 22.8968 3.61426 21.9619 3.61426H2.03863C1.10371 3.61426 0.345825 4.37214 0.345825 5.30706V6.17901C0.345825 6.87713 0.665543 7.50047 1.16644 7.91096Z",
    fill: "url(#paint6_linear_388_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.76917 8.41806H2.58427C1.34804 8.41806 0.345825 7.41589 0.345825 6.17961V4.11872L2.68098 3.97754L5.00761 4.11872V6.17961C5.00761 7.41589 4.0054 8.41806 2.76917 8.41806Z",
    fill: "url(#paint7_linear_388_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.43128 8.41806H7.24638C6.01015 8.41806 5.00793 7.41589 5.00793 6.17961V4.11872L7.32728 3.97754L9.66972 4.11872V6.17961C9.66972 7.41589 8.66751 8.41806 7.43128 8.41806Z",
    fill: "url(#paint8_linear_388_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0917 8.41806H11.9068C10.6705 8.41806 9.66833 7.41589 9.66833 6.17961V4.11872L11.9719 3.97754L14.3301 4.11872V6.17961C14.3301 7.41589 13.3279 8.41806 12.0917 8.41806Z",
    fill: "url(#paint9_linear_388_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7574 8.41806H16.5726C15.3363 8.41806 14.3341 7.41589 14.3341 6.17961V4.11872L16.6218 3.97754L18.9958 4.11872V6.17961C18.9959 7.41589 17.9937 8.41806 16.7574 8.41806Z",
    fill: "url(#paint10_linear_388_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4176 8.41824H21.2327C19.9965 8.41824 18.9943 7.41608 18.9943 6.17979V4.1189L21.3283 3.93066L23.6561 4.1189V6.17979C23.6561 7.41608 22.6539 8.41824 21.4176 8.41824Z",
    fill: "url(#paint11_linear_388_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.219 0H4.96168C4.3839 0 3.84775 0.277365 3.54648 0.732047L0.345825 4.11849H5.00761L7.219 0Z",
    fill: "url(#paint12_linear_388_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4069 0H7.21932L5.00793 4.11849H9.66972L10.4069 0Z",
    fill: "url(#paint13_linear_388_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5929 0H10.4055L9.66833 4.11849H14.3301L13.5929 0Z",
    fill: "url(#paint14_linear_388_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7814 0H13.5939L14.331 4.11849H18.9928L16.7814 0Z",
    fill: "url(#paint15_linear_388_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0387 0H16.7814L18.9928 4.11849H23.6546L20.4539 0.732047C20.1526 0.277365 19.6165 0 19.0387 0Z",
    fill: "url(#paint16_linear_388_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4164 15.4593L15.2797 8.32208C15.1254 8.16824 14.9168 8.08203 14.699 8.08203H10.3748C9.9999 8.08203 9.69543 8.38603 9.69543 8.76095V13.0851C9.69543 13.303 9.78212 13.512 9.93595 13.6658L17.0731 20.8025C17.2571 20.9865 17.5555 20.9865 17.7395 20.8025L22.4164 16.1257C22.6004 15.9417 22.6004 15.6432 22.4164 15.4593ZM11.7859 10.844C11.3712 10.844 11.0352 10.5076 11.0352 10.0923C11.0352 9.67709 11.3712 9.34114 11.7859 9.34114C12.2012 9.34114 12.5381 9.67714 12.5381 10.0923C12.5381 10.5076 12.2012 10.844 11.7859 10.844Z",
    fill: "url(#paint17_linear_388_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4156 15.4595L15.684 8.72735L15.6835 8.72688C15.5292 8.57352 15.3211 8.4873 15.1033 8.4873H10.7791C10.4042 8.4873 10.0997 8.7913 10.0997 9.16622V13.4904C10.0997 13.7082 10.1864 13.9168 10.3398 14.0706L10.3402 14.0711L17.0724 20.8027C17.2564 20.9867 17.5548 20.9867 17.7388 20.8027L22.4156 16.1259C22.5996 15.9419 22.5996 15.6434 22.4156 15.4595ZM11.0345 10.0926C11.0345 9.67733 11.3705 9.34138 11.7852 9.34138C12.098 9.34138 12.3663 9.53229 12.4794 9.80387C12.517 9.89286 12.5373 9.99018 12.5373 10.0926C12.5373 10.5078 12.2004 10.8442 11.7852 10.8442C11.6833 10.8442 11.5859 10.8239 11.4974 10.7873C11.2254 10.6742 11.0345 10.4058 11.0345 10.0926Z",
    fill: "url(#paint18_linear_388_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4164 16.1257C22.5466 15.9954 22.5846 15.8073 22.5303 15.6437C22.5081 15.576 22.4701 15.5125 22.4164 15.4593L15.2797 8.32208C15.2152 8.25813 15.142 8.20622 15.0623 8.1673C14.9507 8.11168 14.8264 8.08203 14.699 8.08203H10.3748C10.2817 8.08203 10.1927 8.10104 10.1116 8.13488C10.1218 9.23643 10.4582 10.1239 10.9786 10.5562L19.4824 19.0601L22.4164 16.1257ZM11.7859 10.844C11.3711 10.844 11.0352 10.5076 11.0352 10.0923C11.0352 9.67709 11.3711 9.34114 11.7859 9.34114C12.2012 9.34114 12.5381 9.67714 12.5381 10.0923C12.5381 10.5076 12.2012 10.844 11.7859 10.844Z",
    fill: "url(#paint19_linear_388_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7365 10.8439C10.795 10.8439 10.1117 9.68221 10.1117 8.08164C10.1117 6.48108 10.795 5.31934 11.7365 5.31934C12.678 5.31934 13.3614 6.48108 13.3614 8.08164H12.0786C12.0786 7.41294 11.916 6.94635 11.7843 6.72527C11.7628 6.68922 11.7103 6.68922 11.6889 6.72527C11.5571 6.94635 11.3945 7.41294 11.3945 8.08164C11.3945 8.83214 11.5994 9.32804 11.7355 9.508C11.8204 9.39515 11.9706 9.35378 12.099 9.41223C12.766 9.71562 12.6448 10.7067 11.9222 10.8283C11.8536 10.8398 11.7909 10.8439 11.7365 10.8439Z",
    fill: "url(#paint20_linear_388_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3461 6.16406C11.9532 6.16406 11.6859 6.72496 11.6859 6.72496C11.7074 6.68891 11.7598 6.68891 11.7813 6.72496C11.913 6.94604 12.0757 7.41263 12.0757 8.08133H13.3012C13.3012 7.02246 12.8736 6.16406 12.3461 6.16406Z",
    fill: "url(#paint21_linear_388_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.099 9.41187C11.9706 9.35342 11.8204 9.39479 11.7355 9.50768C11.6665 9.41658 11.5801 9.24415 11.5114 8.99902H10.1937C10.4015 10.1069 10.987 10.8436 11.7365 10.8436C11.7909 10.8436 11.8536 10.8395 11.9222 10.828C12.6447 10.7064 12.7659 9.71526 12.099 9.41187Z",
    fill: "url(#paint22_linear_388_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1677 18.8979L13.459 17.1897L12.0274 15.7581V12.3149C12.0051 12.1627 12.0306 12.0331 12.1088 11.9549C12.2109 11.8529 12.4504 11.7931 12.5645 11.9073C12.7055 12.0483 12.5738 12.3597 12.8524 12.6383C12.9338 12.7197 13.0389 12.7871 13.1417 12.7994L13.1431 11.4765C13.1201 11.2404 13.1708 11.0018 13.3919 10.7807C13.8413 10.3313 14.4042 10.5528 14.7789 10.9275C14.9195 11.0681 15.2552 11.4506 15.1677 11.6987V18.8979Z",
    fill: "url(#paint23_linear_388_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5366 20.2693L15.1657 18.8983L13.457 17.1901V13.9197C13.431 13.8248 13.4347 13.7319 13.4915 13.6752C13.5005 13.6661 13.5153 13.6574 13.5307 13.6486L15.1656 12.7773L15.9156 12.3777C16.0536 12.306 16.2392 12.3902 16.377 12.528C16.508 12.659 16.5901 12.8325 16.5366 12.9678L16.5366 20.2693Z",
    fill: "url(#paint24_linear_388_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7523 20.7868L17.7367 20.8023C17.5526 20.9864 17.2542 20.9864 17.0702 20.8026L15.3326 19.0649V15.863C15.2975 15.7837 15.2971 15.6997 15.3586 15.6382L17.2645 13.7323C17.3633 13.6335 17.522 13.7086 17.6388 13.8254C17.746 13.9326 17.8179 14.0751 17.7523 14.1741V16.1935V20.7868Z",
    fill: "url(#paint25_linear_388_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1773 18.3634L17.7388 20.8019C17.5547 20.986 17.2562 20.986 17.0723 20.8022L16.8092 20.539V17.337C16.7741 17.2578 16.7736 17.1737 16.8351 17.1122L18.7382 15.2091C18.834 15.1134 18.9832 15.1673 19.0852 15.2693L20.1521 16.3362C20.2151 16.3992 20.2125 16.4819 20.1772 16.5584L20.1773 18.3634Z",
    fill: "url(#paint26_linear_388_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3409 12.7314C13.7035 12.3688 12.6906 11.4818 13.3918 10.7807C13.8413 10.3312 14.4046 10.5529 14.7792 10.9275C14.9381 11.0863 15.3456 11.5537 15.1118 11.7875C15.031 11.8684 14.8122 11.9792 14.6804 11.8474C14.5725 11.7396 14.6294 11.5688 14.3837 11.3231C14.171 11.1103 13.9971 11.1103 13.9042 11.2032C13.6046 11.5029 14.6114 12.3959 13.8563 13.151C13.4247 13.5825 12.8764 13.5016 12.4419 13.0671C12.0493 12.6745 11.9115 12.1531 12.1093 11.9553C12.2111 11.8534 12.4509 11.7935 12.5647 11.9073C12.7056 12.0482 12.5737 12.3598 12.8524 12.6385C12.9903 12.7764 13.1971 12.8753 13.3409 12.7314Z",
    fill: "url(#paint27_linear_388_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4916 13.6754C13.5006 13.6664 13.5156 13.6574 13.5306 13.6484L15.9159 12.3779C16.0537 12.306 16.2395 12.3899 16.3773 12.5277C16.5152 12.6655 16.5991 12.8513 16.5272 12.9892L15.2596 15.3774C15.2507 15.3924 15.2417 15.4074 15.2327 15.4164C15.1218 15.5273 14.8701 15.4374 14.7412 15.3086C14.6663 15.2336 14.6304 15.1497 14.6753 15.0688L14.948 14.5924L14.3157 13.9601L13.8392 14.2328C13.7583 14.2777 13.6744 14.2418 13.5995 14.1669C13.4706 14.038 13.3807 13.7862 13.4916 13.6754ZM15.2087 14.1339L15.793 13.112L14.7712 13.6964L15.2087 14.1339Z",
    fill: "url(#paint28_linear_388_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4187 15.9859C15.3168 15.884 15.2629 15.7342 15.3588 15.6382L17.2646 13.7324C17.3635 13.6335 17.5223 13.7084 17.6392 13.8253C17.756 13.9422 17.831 14.101 17.7321 14.1999L16.09 15.842L16.7732 16.5252C16.863 16.6151 16.8061 16.762 16.7043 16.8638C16.6024 16.9657 16.4556 17.0227 16.3656 16.9328L15.4187 15.9859Z",
    fill: "url(#paint29_linear_388_1950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4356 16.4469L18.8851 16.8964C18.975 16.9862 18.939 17.1241 18.8431 17.22C18.7622 17.3009 18.6243 17.3548 18.5254 17.2559L18.0759 16.8064L17.5665 17.3158L18.3696 18.1189C18.4595 18.2088 18.4145 18.3556 18.3037 18.4665C18.2078 18.5624 18.0609 18.6253 17.9621 18.5265L16.8953 17.4597C16.7934 17.3578 16.7395 17.208 16.8353 17.1121L18.7382 15.2093C18.8341 15.1133 18.9839 15.1673 19.0858 15.2692L20.1526 16.336C20.2514 16.4349 20.1885 16.5817 20.0926 16.6776C19.9817 16.7885 19.8349 16.8334 19.745 16.7435L18.9419 15.9405L18.4356 16.4469Z",
    fill: "url(#paint30_linear_388_1950)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_388_1950",
    x1: 10.7179,
    y1: 19.6485,
    x2: 14.2783,
    y2: 19.6485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A7889"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6E566E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_388_1950",
    x1: 14.147,
    y1: 22.2577,
    x2: 10.1034,
    y2: 15.4385,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E566E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2191,
    stopColor: "#685168",
    stopOpacity: 0.219
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#564357"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_388_1950",
    x1: 12.0006,
    y1: 21.3203,
    x2: 12.0006,
    y2: 24.5609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A7889"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6E566E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_388_1950",
    x1: 9.0734,
    y1: 5.20823,
    x2: 18.3041,
    y2: 24.8898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A7889"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6E566E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_388_1950",
    x1: 14.5498,
    y1: 16.887,
    x2: 6.50657,
    y2: -0.262708,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A7889"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6E566E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_388_1950",
    x1: 9.64596,
    y1: 6.43635,
    x2: 17.0605,
    y2: 22.2455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F6FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFDCFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_388_1950",
    x1: 12.9606,
    y1: 11.8794,
    x2: 9.3262,
    y2: -11.2622,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E566E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2191,
    stopColor: "#685168",
    stopOpacity: 0.219
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#564357"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_388_1950",
    x1: 1.77415,
    y1: 4.7102,
    x2: 5.2206,
    y2: 8.15665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F82814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_388_1950",
    x1: 6.10676,
    y1: 4.38069,
    x2: 8.85057,
    y2: 7.1245,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#FFCD3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#FFAD2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA325"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_388_1950",
    x1: 11.1406,
    y1: 4.7541,
    x2: 14.0521,
    y2: 7.66568,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F82814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_388_1950",
    x1: 15.6746,
    y1: 4.62234,
    x2: 18.6127,
    y2: 7.56041,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#FFCD3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#FFAD2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA325"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_388_1950",
    x1: 19.7856,
    y1: 4.07335,
    x2: 23.524,
    y2: 7.81179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F82814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_388_1950",
    x1: 2.847,
    y1: 1.12381,
    x2: 5.59171,
    y2: 3.86852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F82814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_388_1950",
    x1: 7.09189,
    y1: 1.20551,
    x2: 9.23015,
    y2: 4.17143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#FFCD3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#FFAD2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA325"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_388_1950",
    x1: 10.17,
    y1: 0.598588,
    x2: 14.0474,
    y2: 4.476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F82814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_388_1950",
    x1: 14.6543,
    y1: 0.803859,
    x2: 17.3832,
    y2: 4.60226,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#FFCD3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#FFAD2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA325"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_388_1950",
    x1: 18.2446,
    y1: 0.924847,
    x2: 23.0912,
    y2: 5.77144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F82814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_388_1950",
    x1: 16.9063,
    y1: 10.5146,
    x2: 13.4307,
    y2: 18.2536,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F82814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_388_1950",
    x1: 11.7611,
    y1: 12.822,
    x2: 8.03638,
    y2: 11.2628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7044",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA325"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_388_1950",
    x1: 15.0833,
    y1: 13.2098,
    x2: 8.86825,
    y2: 12.1054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_388_1950",
    x1: 10.1117,
    y1: 8.0816,
    x2: 13.3614,
    y2: 8.0816,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A7889"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6E566E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_388_1950",
    x1: 13.1759,
    y1: 7.60736,
    x2: 11.272,
    y2: 6.58397,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E566E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8228,
    stopColor: "#59465A",
    stopOpacity: 0.866
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#564357"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_388_1950",
    x1: 10.9947,
    y1: 9.72293,
    x2: 13.138,
    y2: 10.5281,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E566E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8228,
    stopColor: "#59465A",
    stopOpacity: 0.866
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#564357"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_388_1950",
    x1: 13.6623,
    y1: 14.281,
    x2: 13.251,
    y2: 10.4401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_388_1950",
    x1: 15.1269,
    y1: 16.7929,
    x2: 14.7671,
    y2: 11.8801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_388_1950",
    x1: 16.7658,
    y1: 17.9824,
    x2: 16.1692,
    y2: 14.1227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_388_1950",
    x1: 18.59,
    y1: 18.9502,
    x2: 18.032,
    y2: 16.1598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_388_1950",
    x1: 14.3457,
    y1: 11.1838,
    x2: 13.0433,
    y2: 12.4863,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F6FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFDCFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_388_1950",
    x1: 16.0304,
    y1: 12.8707,
    x2: 14.728,
    y2: 14.1731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F6FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFDCFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_388_1950",
    x1: 17.7176,
    y1: 14.5577,
    x2: 16.4152,
    y2: 15.8601,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F6FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFDCFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_388_1950",
    x1: 19.2568,
    y1: 16.0942,
    x2: 17.9544,
    y2: 17.3966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F6FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFDCFB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_388_1950"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPricingFreePlan);
export default __webpack_public_path__ + "static/media/pricing-free-plan.7c75ba3e5b778ee99a05d487aa96399d.svg";
export { ForwardRef as ReactComponent };